import '@vueup/vue-quill/dist/vue-quill.snow.css';

export default defineNuxtPlugin(async (nuxtApp) => {

    if (!process.server) {
        const {QuillEditor} = await import('@vueup/vue-quill');
        nuxtApp.vueApp.component('QuillEditor', QuillEditor);
    }

})